export default {
      id: "pdf_alt-usage",
      viewBox: "0 0 16 16.6",
      url: __webpack_public_path__ + "svg/sprite.svg#pdf_alt",
      toString: function () {
        return this.url;
      }
    }